import React, { useState, useEffect } from "react";
import apiClient from "../components/apiClient";
import Navbar from "../components/Navbar";

const OrderPage = () => {
  const [orders, setOrders] = useState([]);
  const [orderItems, setOrderItems] = useState([]);
  const [activeTab, setActiveTab] = useState("pending");
  const [showCards, setShowCards] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [totalWeight, setTotalWeight] = useState(0);
  const [shipping, setShipping] = useState(0);
  const [displayedOrders, setDisplayedOrders] = useState([]);
  const [produk, setProduk] = useState([]); // show 5 orders initially

  useEffect(() => {
    const fetchOrders = async () => {
      if (!userid) return;
      try {
        const token = localStorage.getItem("token");
        const response = await apiClient.get(`/order/user/${userid}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setOrders(response.data);
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };
    fetchOrders();
  }, []);

  const userId = localStorage.getItem("userid");

  useEffect(() => {
  const fetchOrdersAndProducts = async () => {
    if (!userid) return;
    try {
      const token = localStorage.getItem("token");

      // Step 1: Fetch orders
      const response = await apiClient.get(`/order/user/${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const orders = response.data;
      setOrders(orders); // optional if you need order list

      // Step 2: Get unique produkIds
      const produkIds = [
        ...new Set(orders.map((item) => item.produkId)),
      ];

      // Step 3: Fetch all product details using produkId
      const produkRequests = produkIds.map((id) =>
        apiClient.get(`/produk/all/${id}`)
      );
      const produkResponses = await Promise.all(produkRequests);
      const produkList = produkResponses.map((res) => res.data);

      // Step 4: Set product list
      setProduk(produkList);
    } catch (error) {
      console.error("Error fetching orders or products:", error);
    }
  };

  fetchOrdersAndProducts();
}, [userId]);


  const filteredOrders = orders.filter(
    (item) => item.order?.status === activeTab
  );

  // const filteredOrders =
  //   activeTab === "all transaction"
  //     ? orders
  //     : orders.filter((item) => item.order?.status === activeTab);

  // const tabList = [
  //   "pending",
  //   "paid",
  //   "packing",
  //   "shipping",
  //   "finish",
  //   "cancelled",
  //   // "all transaction",
  // ];

  const tabList = [
    { key: "pending", label: "pending" },
    { key: "paid", label: "paid" },
    { key: "packing", label: "packing" },
    { key: "pengiriman", label: "shipping" },
    { key: "terkirim", label: "finish" },
    { key: "cancel", label: "cancelled" },
    { key: "failed", label: "failed" },
  ];

  const totalHargaPerItem = filteredOrders.reduce(
    (sum, item) => sum + item.harga_per_item * item.jumlah,
    0
  );

  // Ambil data pesanan saat komponen dimuat
  const userid = localStorage.getItem("userId");
  console.log(userid);

  useEffect(() => {
    const fetchOrders = async () => {
      if (!userid) return;
      try {
        const token = localStorage.getItem("token");
        const response = await apiClient.get(`/order/user/${userid}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setOrders(response.data);
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };
    fetchOrders();
  }, []);

  // Get order ID from localStorage
  const orderId = localStorage.getItem("orderId");

  const groupedOrders = filteredOrders.reduce((acc, item) => {
    const id = item.orderId;
    if (!acc[id]) acc[id] = [];
    acc[id].push(item);
    return acc;
  }, {});

  const formatRupiah = (angka) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    }).format(angka);
  };
  const handleDetailClick = (orderId, items) => {
    setSelectedOrder(orderId);
    setShowCards(true);
  };

  const handleBack = (index) => {
    setShowCards(false);
  };

  useEffect(() => {
    const weight = localStorage.getItem("totalWeight");
    if (weight) {
      setTotalWeight(Number(weight));
    }
  }, []);

  useEffect(() => {
    const shipping = localStorage.getItem("selectedOption");
    if (shipping) {
      setShipping(shipping);
    }
  }, []);

  return (
    <>
      <Navbar></Navbar>
      <div>
        {!showCards ? (
          <>
            <h1 className="text-3xl font-bold mb-6">Orders</h1>
            {/* <div className="md:p-8 bg-white rounded-2xl shadow-md pt-0">
              <h1 className="text-3xl font-bold mb-6"></h1>
              {orders.length > 0 ? (
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          No.
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Date
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Order ID
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Image
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Product
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Warna
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Jumlah
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Status
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Virtual Account
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {[...orders]
                        .sort(
                          (a, b) =>
                            new Date(b.order.createdAt) -
                            new Date(a.order.createdAt)
                        )
                        .map((order, index) => (
                          <tr
                            key={order.id}
                            className="hover:bg-gray-50 transition"
                          >
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                              {index + 1}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                              {new Date(order.createdAt).toLocaleDateString(
                                "id-ID",
                                {
                                  day: "numeric",
                                  month: "long",
                                  year: "numeric",
                                }
                              )}
                            </td>
                            <td className="px-2 py-2 text-sm font-medium text-gray-900 truncate max-w-[100px] cursor-pointer hover:max-w-none hover:whitespace-normal">
                              {order.orderId}
                            </td>
                            <td className="px-2 py-2 text-sm font-medium text-gray-900 truncate max-w-[100px] cursor-pointer hover:max-w-none hover:whitespace-normal">
                              <img
                                src={order.image}
                                alt="Product Image"
                                className="w-16 h-16 object-cover"
                              />
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                    
                              {order.nama_produk}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                              {order.nama_warna}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                              {order.jumlah}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                              {order.order.status}
                            </td>
                            <td className="px-2 py-2 text-sm font-medium text-gray-900 truncate max-w-[100px] cursor-pointer hover:max-w-none hover:whitespace-normal">
                              <a
                                href={order.order.vaurl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hover:underline"
                              >
                                {order.order.vaurl}
                              </a>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="text-center text-gray-500">No orders found.</p>
              )}
            </div> */}
            <div className="w-full max-w-5xl mx-auto mt-16 px-4">
              {/* Tabs */}
              <div className="flex flex-wrap justify-start border-b">
                {tabList.map((tab) => (
                  <button
                    key={tab.key}
                    onClick={() => setActiveTab(tab.key)}
                    className={`px-4 py-2 capitalize transition-colors duration-300 hover:text-black ${
                      activeTab === tab.key
                        ? "border-b-2 border-blue-500 text-black font-bold"
                        : "text-gray-500 hover:text-black"
                    }`}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>

              {/* Divider */}
              <div className="border-b border-gray-300 mb-6"></div>

              {/* Orders */}
              {/* <div className="mt-4 space-y-6"> */}
              <div className="mt-4 space-y-6 max-h-[600px] overflow-y-auto pr-2">
                {Object.entries(groupedOrders).length > 0 ? (
                  Object.entries(groupedOrders).map(([orderId, items]) => {
                    const totalHarga = items.reduce(
                      (sum, item) => sum + item.harga * item.jumlah,
                      0
                    );
                    const priceekspedisi = items[0]?.order?.harga_kirim;
                    const diskon = items[0]?.order?.diskon || 0;

                    return (
                      <div
                        key={orderId}
                        className="border rounded-lg shadow-sm p-4 bg-white"
                      >
                        {/* Order Header */}
                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4">
                          <div className="text-sm text-gray-500">
                            Order ID
                            <br />
                            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-4 mb-4">
                              <div className="text-sm text-gray-600">
                                <span className="block sm:inline font-bold text-base ml-1 text-black">
                                  #{orderId.slice(-7)}
                                </span>
                              </div>
                              {/* <div className="text-sm text-gray-600">
                                <span className="block sm:inline font-bold text-base ml-1 text-black">
                                  {items[0]?.order?.status}
                                </span>
                              </div> */}
                            </div>
                          </div>
                        </div>

                        {/* <div className="text-sm text-gray-500">Order ID</div>

                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4">
                          <div className="flex justify-between items-center w-full sm:mt-0 mt-1">
                            <span className="font-bold text-base text-black">
                              #{orderId.slice(-7)}
                            </span>
                            <span className="font-bold text-base text-black">
                              {items[0]?.order?.status}
                            </span>
                          </div>
                        </div> */}

                        {/* Product Items */}
                        <div className="flex flex-wrap -mx-2">
                          {items.map((item) => (
                            <div
                              key={item.id}
                              className="w-full md:w-1/2 px-2 mb-4 flex"
                            >
                              <div className="flex items-start gap-4 p-4 border rounded-lg shadow-sm w-full bg-gray-50">
                                <img
                                  src={item.image}
                                  alt="Product"
                                  className="w-20 h-20 object-cover rounded"
                                />
                                <div className="flex-1 space-y-1">
                                  <div className="text-base font-semibold text-gray-800">
                                    {item.produk?.brand?.nama_brand || "-"}{" "}
                                    {item.nama_produk}
                                  </div>

                                  <div className="text-sm text-gray-600">
                                    Harga: Rp
                                    {item.harga.toLocaleString()}
                                  </div>
                                  {/* <div className="text-sm text-gray-600">
                                    Jumlah: {item.jumlah}
                                  </div> */}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>

                        {/* Footer */}
                        <div className="flex justify-between items-center mt-4 pt-4 border-t">
                          <h3 className="text-lg font-semibold text-gray-800">
                            Total Harga:{" "}
                            {/* {formatRupiah(totalHarga + priceekspedisi)} */}
                            {formatRupiah(
                              (totalHarga - (totalHarga * diskon) / 100 || 0) +
                                priceekspedisi
                            )}
                          </h3>
                          {/* <button
                            onClick={() => handleDetailClick(orderId, items)}
                            className="mt-2 sm:mt-0 text-sm border border-black bg-gray-300 text-black px-4 py-1 rounded hover:text-white hover:bg-black transition"
                          >
                            Leave a Review
                          </button> */}
                          <button
                            onClick={() => handleDetailClick(orderId, items)}
                            className="mt-2 sm:mt-0 text-sm border border-black bg-white text-black px-4 py-1 rounded hover:text-white hover:bg-black transition"
                          >
                            Details
                          </button>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="text-center text-gray-500 mt-10">
                    Tidak ada pesanan dengan status <strong>{activeTab}</strong>
                  </div>
                )}
              </div>
            </div>
          </>
        ) : (
          <>
            <h1 className="text-3xl font-bold mb-6">Order Detail</h1>

            <div className="w-full max-w-5xl mx-auto mt-16 px-4">
              {/* Orders */}
              <div className="mt-4 space-y-6">
                {groupedOrders[selectedOrder] ? (
                  (() => {
                    const items = groupedOrders[selectedOrder];
                    const totalHarga = items.reduce(
                      (sum, item) => sum + item.harga * item.jumlah,
                      0
                    );

                    const alamat =
                      items[0]?.order?.alamatpengiriman?.alamat ||
                      "Alamat tidak tersedia";
                    const namapenerima =
                      items[0]?.order?.alamatpengiriman?.namapenerima;
                    const kotaataukelurahan =
                      items[0]?.order?.alamatpengiriman?.kotaataukelurahan;
                    const provinsi =
                      items[0]?.order?.alamatpengiriman?.provinsi;
                    const kodePos = items[0]?.order?.alamatpengiriman?.kodePos;
                    const kodeekspedisi = items[0]?.order?.kode_ekspedisi;
                    const typeekspedisi = items[0]?.order?.nama_ekspedisi;
                    const priceekspedisi = items[0]?.order?.harga_kirim;
                    const estimasi = items[0]?.order?.lama_kirim;
                    const dateCreate = new Date(items[0]?.order?.createdAt);
                    const formattedDate = dateCreate.toLocaleString("id-ID", {
                      timeZone: "Asia/Jakarta",
                      dateStyle: "long",
                      timeStyle: "short",
                    });
                    const no_resi = items[0]?.order?.noresi;
                    const state = items[0]?.order?.status;
                    const diskon = items[0]?.order?.diskon || 0;

                    return (
                      <div
                        // key={orderId}
                        className="border rounded-lg shadow-sm p-4 bg-white"
                        // {!showCards ? (
                      >
                        {/* Order Header */}
                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-4 mb-4">
                          {/* Order ID Section */}
                          <div className="text-sm text-gray-600">
                            <p className="mb-1 font-medium">Order ID</p>
                            <p className="text-base font-bold text-black">
                              #{selectedOrder.slice(-7)}
                            </p>
                            <p className="text-base font-bold text-black">
                              {formattedDate}
                            </p>
                            <p className="text-base font-bold text-black">
                              {state}
                            </p>
                          </div>

                          {/* Recipient & Address Section */}
                          <div className="border-t md:border-t-0 md:border-l border-gray-200 flex flex-col md:flex-row md:justify-between md:items-start bg-white p-4 md:p-6 gap-6 text-sm text-gray-700">
                            {/* Left Section - Recipient & Tracking */}
                            <div className="md:w-1/2 space-y-4">
                              <div>
                                <p className="text-gray-500 font-medium">
                                  Recipient
                                </p>
                                <p className="text-base font-bold text-black">
                                  {namapenerima}
                                </p>
                              </div>

                              <div>
                                <p className="text-gray-500 font-medium">
                                  Tracking No.
                                </p>
                                <p className="text-base font-bold text-black">
                                  {kodeekspedisi} {no_resi}
                                </p>
                              </div>
                            </div>

                            {/* Right Section - Address */}
                            <div className="md:w-1/2 space-y-2">
                              <p className="text-gray-500 font-medium">
                                Address
                              </p>
                              <div className="text-base font-semibold text-black leading-snug space-y-0.5">
                                <p>{alamat}</p>
                                <p>{kotaataukelurahan}</p>
                                <p>{provinsi}</p>
                                <p>{kodePos}</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Product Items */}
                        <div className="flex flex-wrap -mx-2">
                          {items.map((item) => (
                            <div
                              key={item.id}
                              className="w-full md:w-1/2 px-2 mb-4 flex"
                            >
                              <div className="flex items-start gap-4 p-4 border rounded-lg shadow-sm w-full bg-gray-50">
                                <img
                                  src={item.image}
                                  alt="Product"
                                  className="w-20 h-20 object-cover rounded"
                                />
                                <div className="flex-1 space-y-1">
                                  <div className="text-base font-semibold text-gray-800">
                                    {item.produk?.brand?.nama_brand || "-"}{" "}
                                    {item.nama_produk}
                                  </div>
                                  <div className="text-sm text-gray-600">
                                    Warna: {item.nama_warna}
                                  </div>
                                  <div className="text-sm text-gray-600">
                                    Harga: Rp
                                    {item.harga.toLocaleString()}
                                  </div>
                                  <div className="text-sm text-gray-600">
                                    Jumlah: {item.jumlah}
                                  </div>
                                  <div className="text-sm text-gray-600">
                                    Status:{" "}
                                    <span className="capitalize">
                                      {item.order?.status}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>

                        {/* Footer */}
                        <div className="flex justify-between items-center mt-4 pt-4 border-t">
                          <div>
                            {/* <p className="text-sm text-gray-600">
                              Shipping: {shipping || "No Shipping Destination"}
                            </p> */}
                            <p className="text-sm text-gray-600">
                              Ekspedisi: {kodeekspedisi}
                            </p>
                            <p className="text-sm text-gray-600">
                              Tipe: {typeekspedisi}
                            </p>
                            <p className="text-sm text-gray-600">
                              Harga: {formatRupiah(priceekspedisi)}
                            </p>
                            <p className="text-sm text-gray-600">
                              Estimasi: {estimasi}
                            </p>
                            <p className="text-sm text-gray-600">
                              Total Berat: {totalWeight} kg
                            </p>

                            <p className="text-sm  text-gray-600">
                              Applied code discount: {diskon}%
                            </p>
                            <h3 className="text-sm text-gray-600">
                              Subtotall: {formatRupiah(totalHarga)}
                            </h3>

                            <h3 className="text-lg font-semibold text-gray-800">
                              Total Harga:{" "}
                              {formatRupiah(
                                (totalHarga - (totalHarga * diskon) / 100 ||
                                  0) + priceekspedisi
                              )}
                            </h3>
                          </div>
                          <button
                            onClick={() => setShowCards(false)}
                            className="text-sm bg-black text-white px-4 py-1 rounded hover:bg-gray-300 hover:text-black transition"
                          >
                            Back
                          </button>
                        </div>
                      </div>
                    );
                  })()
                ) : (
                  <div className="text-center text-gray-500 mt-10">
                    Tidak ada pesanan dengan status <strong>{activeTab}</strong>
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default OrderPage;
